export default __webpack_public_path__ + "media/images/steps/step-2-ee136e8fbe6b98e1427f4fc2cc389506.svg";